<template>
  <footer class="footer">
    <div class="companyInfo">
      <a class="accordionBtn" @click="toggleAccordion">
        <span class="accordionTitle">넥슨코리아 사업자 정보</span>
        <i class="icon" :class="open ? 'iconUp2' : 'iconDown2'"></i>
      </a>

      <transition name="accordion">
        <div class="accordionData" :class="open ? 'open' : ''">
          <ul class="dataList">
            <li>
              <span>대표이사</span>
              강대현·김정욱
            </li>
            <li>
              <span>주소</span>
              경기도 성남시 분당구 판교로 256번길 7
            </li>
            <li>
              <span>사업자등록번호</span>
              220-87-17483호
            </li>
            <li>
              <span>통신판매업 신고번호</span>
              제2013-경기성남-1659호
            </li>
          </ul>
        </div>
      </transition>
    </div>

    <nav class="navigationFooter">
      <ul class="policy">
        <li>
          <a href="https://member.nexon.com/policy/stipulation.aspx">
            이용약관
          </a>
        </li>
        <li>
          <a href="https://member.nexon.com/policy/privacy.aspx">
            <strong>개인정보처리방침</strong>
          </a>
        </li>
      </ul>
    </nav>
    <div class="copyright">ⓒ NEXON Korea Corporation All Rights Reserved.</div>
  </footer>
</template>

<script>
export default {
  name: 'ShopFooter',
  data() {
    return {
      open: false
    }
  },
  methods: {
    toggleAccordion() {
      this.open = !this.open
    }
  }
}
</script>

<style lang="scss">
.footer {
  position: static;
  z-index: 999;

  // DO : 배송/펀딩상품 추가 - footer 스타일 수정
  max-width: 640px;
  margin: 0 auto 55px;
  font-family: 'Malgun Gothic', 'Nanum Gothic';
  text-align: center;
  //background-color: #f7f7f7;

  .companyInfo {
    display: block;
    max-width: 640px;
    margin: 0 auto;
  }
  .navigationFooter {
    max-width: 640px;
    margin: 0 auto;
    padding-top: 18px;

    .policy {
      display: block;
      padding: 2px 0;

      li {
        display: inline-block;
        margin: 0 3px;
        color: #d1d2d4;
        font-size: 11px;

        &:first-child::after {
          display: inline-block;
          content: '|';
          margin: -1px 0 0 6px;
          vertical-align: top;
        }
      }
    }
  }
  a {
    color: #555;
    font-size: 11px;
  }
  .copyright {
    padding-top: 5px;
    color: #777;
    font-size: 10px;
  }
}

// DO -> 결제하기 페이지 외에 모두 노출

.order + .footer {
  padding: 0;
  .companyInfo {
    display: none;
  }
  .navigationFooter {
    .policy {
      display: none;
    }
  }
}

.main + .footer,
.category + .footer {
  .navigationFooter {
    max-width: 100%;
  }
}
.footer {
  // safeArea
}
.order + .footer {
  // safeArea
}
.cart + .footer {
  // safeArea
}

@media all and (max-width: 640px) {
  .footer {
    .companyInfo {
      .accordionData {
        .dataList {
          width: auto;
        }
      }
    }
  }
}
</style>
